import api from "./api"

export const getUser = async (userId) => {
    const response = api.get(`/user-authenticate/${userId}`)
    return response
}

export const fnGetUsers = async () => {
    const response = api.get(`/operational-panel-users`)
    return response
}

export const fnGetUsersAndTeams = async () => {
    const response = await api.get(`/operational-panel-users-and-teams`);
    return response.data;
};
  

export const logout = async () => {
    const response = api.get("/logout")
    return response
}

export const fnGeStatusLogin = async () => {
    const response = api.get("/status/login")
    return response
}

export function fnChangeCostumer(cust_id) {
    const response = api.get(`/customer/connect/${cust_id}`)
    return response
}